import { useEffect } from 'react';
import { useMediaDevice } from '../../hooks';
import LoopPlayback from './LoopPlayback';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('Oasis.Brands');
    const { isH5, isPad, isDesktop, isPC } = useMediaDevice();
    const list = [
        'https://websiteoss.ecoflow.com/upload/image/1743669684419/Google.png',
        'https://websiteoss.ecoflow.com/upload/image/1743669684184/kasa.png',
        'https://websiteoss.ecoflow.com/upload/image/1743669684008/Nordpool.png',
        'https://websiteoss.ecoflow.com/upload/image/1743669683901/Octopus.png',
        'https://websiteoss.ecoflow.com/upload/image/1743669683678/Rabot%20charge.png',
        'https://websiteoss.ecoflow.com/upload/image/1743669683397/Shelly.png',
        'https://websiteoss.ecoflow.com/upload/image/1743669683202/Smart%20Thermostats%20%20Smart%20Home%20Devices%20%20ecobee%201.png',
        'https://websiteoss.ecoflow.com/upload/image/1743669682612/tibber-logo-fixed%201.png',
        'https://websiteoss.ecoflow.com/upload/image/1743669682992/tado%C2%B0.png',
        'https://websiteoss.ecoflow.com/upload/image/1743669682784/Tapo%20%20Smart%20Devices%20for%20Smart%20Living%201.png',
        'https://websiteoss.ecoflow.com/upload/image/1743669682465/EPEX%20Spot.png',
    ];

    useEffect(() => {
        const brands = document.querySelector('#Brands') as HTMLVideoElement;
        if (isH5) {
            brands.style.opacity = '1';
            return;
        }
        const ani = AniContainer.create({
            triggerElement: '#Brands',
            triggerHook: 1,
            offset: 0,
            duration: '200%',
            asyncFromTo: [
                [brands, { opacity: 0 }, { opacity: 0 }, 0.1],
                [brands, { opacity: 0 }, { opacity: 1 }, 0.1],
                [brands, { opacity: 1 }, { opacity: 0 }, 0.1],
                [brands, { opacity: 0 }, { opacity: 0 }, 0.1],
            ],
            asyncTimeLine: [0, 0.1, 0.5, 1],
        });
        return () => {
            ani.destroy();
        };
    }, [isPad, isH5, isDesktop, isPC]);

    return (
        <div className={`${styles.TheComp}`} id="Brands">
            <div className="brand-title">{t('title')}</div>
            {isH5 ? (
                <div>
                    <LoopPlayback list={[list[0], list[1], list[2], list[3], list[4]]} reverse />
                    <LoopPlayback list={[list[5], list[6], list[7], list[8], list[9], list[10]]} />
                </div>
            ) : (
                <LoopPlayback list={list} />
            )}
            <div className="brand-desc">{t('desc')}</div>
        </div>
    );
}
